import PublishStatus from "models/enumerations/publish-status";
import { CollectionUtils } from "utilities/collection-utils";
import PublicationService from "utilities/services/publications/publication-service";
import SectionService from "utilities/services/sections/section-service";
import RecipientAccessShareSpaceItemService from "utilities/services/share-space/recipient-access/share-space-item-service";
import ShareSpaceItemService from "utilities/services/share-space/share-space-items-service";

const getShareSpaceItemsByShareSpaceId = async (shareSpaceId: number) => {
    const response = await ShareSpaceItemService.list({
        shareSpaceId,
    });
    if (response.result?.hasErrors()) {
        throw new Error();
    }

    const sectionIds = response.resultObjects
        .filter((item) => item.sectionId != null)
        .map((item) => item.sectionId!);

    // Get Sections
    const sectionsResponse = CollectionUtils.hasValues(sectionIds)
        ? await SectionService.batchList(
              { sectionIds },
              "sectionIds",
              sectionIds.length
          )
        : { resultObjects: [] };

    const publicationIds = [...sectionsResponse.resultObjects].map(
        (caapsItem) => caapsItem.publicationId!
    );

    // Get Publications
    const publicationResponse = CollectionUtils.hasValues(publicationIds)
        ? await PublicationService.list({ publicationIds })
        : { resultObjects: [] };

    const shareSpaceItemsWithSections = response.resultObjects
        .map((item) => {
            return item.with({
                section: sectionsResponse.resultObjects.find(
                    (section) => section.externalId === item.externalId
                ),
                publication: publicationResponse.resultObjects.find(
                    (pub) =>
                        pub.code === item.code &&
                        pub.edition === item.edition &&
                        pub.publishStatus === PublishStatus.Published
                ),
            });
        })
        .sort((a, b) => a.displaySequence! - b.displaySequence!);

    return shareSpaceItemsWithSections;
};

const getShareSpaceItemsByRecipientGuid = async (guid: string) => {
    const shareSpaceItemsResponse =
        await RecipientAccessShareSpaceItemService.list({
            guid,
        });

    const shareSpaceItemsWithPublications =
        shareSpaceItemsResponse.resultObjects.sort(
            (a, b) => a.displaySequence! - b.displaySequence!
        );

    return shareSpaceItemsWithPublications;
};

export const ShareSpaceUtils = {
    GetItemsByShareSpaceId: getShareSpaceItemsByShareSpaceId,
    GetItemsByRecipientGuid: getShareSpaceItemsByRecipientGuid,
};
